import {
    getAllData
} from '@/store/api/method'

const initialState = () => ({
    setting: [],
    msg: 'Jaringan Bermasalah',
    status: 0
})
const state = initialState
 
const getters = {
    getSetting: (state) => (name) => state.setting[name],
    getMsg: state => state.msg,
    getStatus: state => state.status,
}

const actions = {
    async toggleSetting({
        commit
    }, value) {
        try {
            var response = await getAllData(`/setting-toggle/${value}`);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getSetting({
        commit
    }, name) {
        try {
            var response = await getAllData(`/setting/${name}`);
            commit('SET_SETTING', {response: response.data, name: name});
            return response
        } catch (_) {
            commit('SET_FAILED')
            return { error: 'failed'}
        }
    },
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_SETTING(state, {response,name}) {
        state.setting[name] = response
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}